export default function Logo(): React.ReactElement {
  return (
    <svg width="1024" height="1024" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>xAI</title>
      <path
        d="M128.22 388.746L513.844 932.571H685.252L299.584 388.746H128.22ZM299.452 690.789L128 932.571H299.54L385.2 811.702L299.452 690.789ZM724.46 91.4286L428.096 509.355L513.844 630.311L896 91.4286H724.46ZM755.501 350.032V932.571H896V151.907L755.501 350.032Z"
        fill="#0A0A0A"
      />
    </svg>
  )
}
